// Module
var code = "<ng-include src=\"sortMenuCtrl.getPartial()\"></ng-include> ";
// Exports
module.exports = code;